import type { PrivateEventCrewView } from '../../api/privateEvents';
import { useViewport } from '../../hooks/useViewport';
import { formatVenueDate, formatVenueTime } from '../../utils/venueTime';

import Fact from './Fact';
import PrivateEventLocationValue from './PrivateEventLocationValue';

export default function WhenWhatView({ event }: { event: PrivateEventCrewView }) {
  const { isPhone } = useViewport();
  const start = event.localStartsAt;
  const end = event.localEndsAt;
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: isPhone ? '1fr 1fr' : '1fr 1fr 1fr 1.3fr',
        gap: 14,
      }}
    >
      <Fact label="Date & time">
        <strong>{formatVenueDate(start)}</strong>
        <div style={{ fontSize: 12, color: 'var(--nb-muted)', marginTop: 2 }}>
          {formatVenueTime(start)} – {formatVenueTime(end)}
        </div>
      </Fact>
      <Fact label="Workshop type">{event.workshopTypeName}</Fact>
      <Fact label="Headcount">
        <span className="nb-tabular" style={{ fontWeight: 800, fontSize: 16 }}>
          {event.headcount}
        </span>
        <span style={{ fontSize: 10.5, color: 'var(--nb-subtle)', marginLeft: 5 }}>
          never locked
        </span>
      </Fact>
      <Fact label="Location">
        <PrivateEventLocationValue event={event} />
      </Fact>
    </div>
  );
}
